import { render } from "./Cookies.vue?vue&type=template&id=199d261c&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import "./Cookies.vue?vue&type=style&index=0&id=199d261c&lang=scss"
import "./Cookies.vue?vue&type=style&index=1&id=199d261c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1732206420/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199d261c"]])

export default __exports__